<template>
  <div class="d-flex-column justify-start align-start gap-24">
    <div class="d-flex-row space-between gap-5">
      <label
        class="d-flex-row flex-1 medium-xl font-family-2 t-white"
        v-if="startPoint"
        >{{ startPoint }}</label
      >
      <div class="d-flex-row gap-0 flex-10">
        <div class="range-slider">
          <div class="progress" ref="progress"></div>

          <input
            type="range"
            :step="step"
            :min="min"
            :max="max"
            v-model="sliderMax"
            ref="input_slider"
          />
        </div>
      </div>
      <label
        class="d-flex-row flex-1 medium-xl font-family-2 t-white"
        v-if="endPoint"
        >{{ endPoint }}</label
      >
    </div>
    <div class="d-flex-row space-between">
      <label
        class="t-white medium-xl font-family-2"
        :class="[
          index === 0 ||
          index === steps.length - 1 ||
          index === Math.floor(steps.length / 2)
            ? ''
            : 'md-hide',
        ]"
        v-for="(step, index) in steps"
        :key="step"
        >{{ step.title }}</label
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sliderMax: 0,
      gap: 10,
    };
  },
  props: {
    steps: {
      default: [
        {
          title: "1k",
        },
        {
          title: "10k",
        },
        {
          title: "20k",
        },
        {
          title: "30k",
        },
        {
          title: "40k",
        },
        {
          title: "50k",
        },
        {
          title: "60k",
        },
      ],
    },
    min: {
      default: 1,
    },
    max: {
      default: 10,
    },
    step: {
      default: 1,
    },
    startPoint: {
      default: null,
    },
    endPoint: {
      default: null,
    },

    modelValue: {
      default: null,
    },
    startMin: {
      default: false,
    },
    stock: {
      default: 15,
    },
  },
  mounted() {
    if (this.startMin) {
      this.startFromMin();
    } else {
      this.sliderMax = this.min;
    }
  },
  methods: {
    startFromMin() {
      this.sliderMax = this.min;
      const value = parseInt(this.sliderMax);
      const percValue = value - this.min;
      let add = 0;
      if (this.max === 11000) {
        add = 4;
        if (value === this.min) {
          add = 5;
        }
      }
      this.$refs.progress.style.right =
        Math.ceil(100 - (percValue / this.difference) * 100 + add) + "%";
    },
  },
  computed: {
    difference() {
      return this.max - this.min;
    },
  },
  watch: {
    sliderMax(val) {
      const value = parseInt(this.sliderMax);
      const percValue = value - this.min;
      let add = 0;
      if (this.max === 11000) {
        add = 4;
        if (value === this.min) {
          add = 5;
        }
      }
      this.$refs.progress.style.right =
        Math.ceil(100 - (percValue / this.difference) * 100 + add) + "%";
      this.$emit("update:modelValue", value);
      this.$emit("update:modelValue", value);
    },

    min() {
      this.startFromMin();
    },
    modelValue() {
      if (this.modelValue != this.sliderMax) {
        this.sliderMax = this.modelValue;
      }
    },
  },
};
</script>
